///////////
// Actions

export const addScriptSave = (save) => ({
  type: "ADD_SCRIPT_SAVE",
  payload: save
});

export const addMoreScriptSaves = (saves) => ({
  type: "ADD_MORE_SCRIPT_SAVES",
  payload: saves
});

export const updateScriptSave = (save) => ({
  type: "UPDATE_SCRIPT_SAVE",
  payload: save
});

export const deleteScriptSave = (saveId) => ({
  type: "DELETE_SCRIPT_SAVE",
  payload: saveId
});

///////////
// Reducer

export const scriptSaveReducer = (state = [], action) => {
  switch (action.type) {
    case "ADD_SCRIPT_SAVE":
      if (!state.some((s) => s.saveId === action.payload.saveId)) {
        return [...state, action.payload];
      }
      return state;

    case "ADD_MORE_SCRIPT_SAVES":
      return [
        ...state,
        ...action.payload.filter(
          (save) => !state.some((s) => s.saveId === save.saveId)
        )
      ];

    case "UPDATE_SCRIPT_SAVE":
      return state.map((save) =>
        save.saveId === action.payload.saveId
          ? { ...save, ...action.payload }
          : save
      );

    case "DELETE_SCRIPT_SAVE":
      return state.filter((save) => save.saveId !== action.payload);

    default:
      return state;
  }
};
